<template>
  <EnvBadge :user-email="usStore.formData.email" />
  <PageLoader />
  <SessionExpired v-if="authStore.hasAuthError" />
  <router-view v-else />
  <CookieDialog />
</template>

<script setup>
import useAuthStore from '@shared/stores/useAuthStore.js'
import SessionExpired from '@shared/components/SessionExpired.vue'

import EnvBadge from '@shared/components/EnvBadge.vue'
import PageLoader from '@shared/components/Pageloader.vue'
import { changeLocale } from '@shared/localization'
import { computed, watch } from 'vue'
import { getLangCodeByLanguage } from '@shared/utils'
import useUserStore from '@shared/stores/useUserStore.js'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import useLandingPageStore from '@shared/stores/useLandingPageStore.js'
import useUsStore from '@us/app/stores/useUsStore.js'
import CookieDialog from '@us/app/components/CookieDialog.vue'
import * as apiRequest from '@shared/api-endpoints'

const authStore = useAuthStore()
const userStore = useUserStore()
const corporateStore = useCorporateStore()
const landingPageStore = useLandingPageStore()
const usStore = useUsStore()

const lang = computed(() => userStore.lang)

// update the i18n language whenever the language in the store changes
watch(
  lang,
  (lang) => {
    changeLocale(getLangCodeByLanguage(lang), document.documentElement)
    // reload translations for the corporate
    if (corporateStore.corporate) {
      apiRequest.loadCorporate({
        key: corporateStore.corporate.key,
      })
    }
    // reload landing page content in selected language
    if (landingPageStore.landingPage?.slug) {
      landingPageStore.ensureLandingPage(landingPageStore.landingPage.slug, {
        forceReload: true,
      })
    }
  },
  { immediate: true },
)
</script>
